import educationalBlocksSlice from "@pages/LearningManagement/EducationalBlocks/store/educationalBlocksSlice";
import competencesSlice from "@pages/LearningManagement/Competences/store/competencesSlice";
import educationalSymbolsSlice
    from "@pages/LearningManagement/LearningPlan/PlanSettingsPages/EducationalSymbols/store/educationalSymbolsSlice";
import learningSettingsSlice
    from "@pages/LearningManagement/LearningPlan/PlanSettingsPages/LearningSettings/store/learningSettingsSlice";
import learningPlanSlice from "@pages/LearningManagement/LearningPlan/store/learningPlanSlice";
import electiveSlice from "@pages/LearningManagement/ElectiveSubjects/store/electiveSlice";
import academicStructureSlice from "@pages/LearningManagement/AcademicStructure/store/academicStructureSlice";
import normTypesSlice
    from "@pages/LearningManagement/Workload/components/WorkloadSettingsPages/WorkloadNormTypes/store/normTypesSlice";
import loadCoefficientsSlice
    from "@pages/LearningManagement/Workload/components/WorkloadSettingsPages/WorkloadCoefficients/store/loadCoefficientsSlice";
import normsSlice
    from "@pages/LearningManagement/Workload/components/WorkloadSettingsPages/WorkloadNorms/store/normsSlice";
import academicSchedulingSlice from "@pages/LearningManagement/AcademicScheduling/store/academicSchedulingSlice";
import hourlyWageSlice
    from "@pages/LearningManagement/Workload/components/WorkloadSettingsPages/HourlyWage/store/hourlyWageSlice";
import baselineSlice from "@pages/LearningManagement/Baseline/store/baselineSlice";
import subjectGroupsSlice from "@pages/LearningManagement/SubjectGroups/store/subjectGroupsSlice";
import unitedLessonsSlice from "@pages/LearningManagement/UnitedLessons/store/unitedLessonsSlice";
import workloadSlice from "@pages/LearningManagement/Workload/store/workloadSlice";

export const learningReducer = {
    educationalBlock: educationalBlocksSlice.reducer,
    competences: competencesSlice.reducer,
    educationalSymbols: educationalSymbolsSlice.reducer,
    learningSettings: learningSettingsSlice.reducer,
    learningPlan: learningPlanSlice.reducer,
    elective:electiveSlice.reducer,
    academicStructure: academicStructureSlice.reducer,
    normTypes: normTypesSlice.reducer,
    loadCoefficients: loadCoefficientsSlice.reducer,
    norms: normsSlice.reducer,
    academicScheduling: academicSchedulingSlice.reducer,
    hourlyWage: hourlyWageSlice.reducer,
    baseline: baselineSlice.reducer,
    subjectGroups: subjectGroupsSlice.reducer,
    unitedLessons:unitedLessonsSlice.reducer,
    workload:workloadSlice.reducer,
}